import { Modal, Button } from "react-bootstrap";

const ErrorModal = ({ show, handleClose, errors }) => {
  return (
    <Modal show={show} onHide={handleClose} size="lg" centered>
      <Modal.Header closeButton>
        <Modal.Title>Upload Errors</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {errors?.length > 0 ? (
          <ul>
            {errors.map((err, idx) => (
              <li key={idx} className="text-danger">
                {err}
              </li>
            ))}
          </ul>
        ) : (
          <p>No errors found.</p>
        )}
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={handleClose}>
          Close
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default ErrorModal;
